export const adminUrl = window.globalObject.admin_url + 'admin-ajax.php';

export const PAGES = {
  TYPE_OF_LOAN: 1,
  SUBMITTING_LOAN: 2,
  BORROWER_INFO: 3,
  PASSWORD_SCREEN: 4,
  BORROWER_CREDIT: 8,
  PROPERTY_ADDRESS: 9,
  CONSOLE_BROOK_1: 10,
  LOAN_SUMMARY: 11,
  CONSOLE_BROOK_2: 12,
  CONSOLE_BROOK_3: 13,
  CONSOLE_BROOK_4: 14,
  LOGIN: 15,
  BROKER_INFO: 16,
  BROKER_QUESTION: 17,
  BORROWER_INFO2: 18,
  RESET_PASS_1: 19,
  RESET_PASS_2: 20,
};

export const DB_DATE_FORMAT = 'YYYY-MM-DD';

export const SET_PAGE = 'SET_PAGE';

export const MARGIN_TOP = 15;



// WEBPACK FOOTER //
// ./src/config/constants.js